import React from "react";
import { useSiteConfig } from "../context/SiteConfigContext";

const MapSection = ({ height = "450px" }) => {
  const {siteConfig} = useSiteConfig();
  return (
    <section
      className="mrv-contact-map"
      style={{ height: height }}
    >
      <iframe
        src={siteConfig.mapEmbed}
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        title="MRV School Location"
      ></iframe>
    </section>
  );
};

export default MapSection;
